.toggle {
	display: inline-flex;
	gap: var(--spacing-2);
	align-items: center;
	padding: var(--spacing-2) var(--spacing-3);
	font-size: var(--font-size-sm);
	cursor: pointer;
	background-color: var(--colour-background-surface);
	border: 1px solid var(--colour-border-subtle);
	border-radius: var(--radius-full);

	&:hover {
		border-color: var(--colour-border-strong);
	}

	/* Text label (the glyph is the first span) */
	> span:last-child {
		text-transform: capitalize;
	}

	/* Icon-only: a square button showing just the glyph (collapsed sidebar rail). */
	&[data-icon-only] {
		justify-content: center;
		inline-size: 2rem;
		block-size: 2rem;
		padding: 0;
	}
}
